<ng-container rtBlock="sc-contacts-page">
    <sc-page-header qa-dataid="contacts-header">
        <h1 slot="title" i18n="@@navContacts">Контакты</h1>
        <p slot="lead" rtElem="lead" i18n="@@contactsHeroLead">
            Вопросы по расчёту, white-label и интеграциям. Отвечаем в течение рабочего дня.
        </p>
    </sc-page-header>

    <section rtElem="split">
        <div rtElem="form-col">
            <h2 rtElem="form-title" i18n="@@contactsFormTitle">Форма обратной связи</h2>
            <sc-contact-form qa-dataid="contacts-form" [hideEditorial]="true" [contextData]="lastStairConfig()" />
        </div>

        <aside rtElem="info-col">
            <h2 rtElem="info-title" i18n="@@contactsInfoTitle">Быстрые каналы</h2>

            <div rtElem="info-block">
                <h3 rtElem="info-label" i18n="@@contactsChannelSupport">Поддержка</h3>
                <a rtElem="info-value" qa-dataid="contacts-channel" data-channel="support" href="mailto:staircraftdesigne@gmail.com">
                    staircraftdesigne&#64;gmail.com
                </a>
                <p rtElem="info-text" i18n="@@contactsChannelSupportText">Ответ в течение рабочего дня</p>
            </div>

            <div rtElem="info-block">
                <h3 rtElem="info-label" i18n="@@contactsChannelPartners">White-label и интеграции</h3>
                <a rtElem="info-value" qa-dataid="contacts-channel" data-channel="partners" href="mailto:staircraftdesigne@gmail.com">
                    staircraftdesigne&#64;gmail.com
                </a>
                <p rtElem="info-text" i18n="@@contactsChannelPartnersText">Партнёрство и встраивание калькулятора</p>
            </div>

            <div rtElem="info-block">
                <h3 rtElem="info-label" i18n="@@contactsChannelPrivacy">Персональные данные</h3>
                <a rtElem="info-value" qa-dataid="contacts-channel" data-channel="privacy" href="mailto:staircraftdesigne@gmail.com">
                    staircraftdesigne&#64;gmail.com
                </a>
                <p rtElem="info-text" i18n="@@contactsChannelPrivacyText">Запросы по политике конфиденциальности</p>
            </div>
        </aside>
    </section>
</ng-container>
